var btnStyle = function (mode, curMode) {
  if (mode == curMode) {
    return {
      'background': '#1473FF',
      'color': '#ffffff'
    };
  }

  return {
    'background': '#FFFFFF',
    'color': '#333333'
  };
};

module.exports = {
  btnStyle: btnStyle
};